// Banner shown at the top of any Visual Editor dialog when the resource is
// locked by another admin or the current admin has just lost their lock.
import { AlertTriangle, LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";

function friendlyAge(sec) {
  if (sec == null) return "";
  if (sec < 30) return "just now";
  if (sec < 90) return "a minute ago";
  const m = Math.round(sec / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  return `${h}h ago`;
}

export default function EditLockBanner({ status, holder, onTakeOver, onClose }) {
  if (status !== "locked" && status !== "lost") return null;
  const who = holder?.user_name || "another admin";
  const initials = (who[0] || "?").toUpperCase();
  const isLost = status === "lost";
  const label = isLost ? "Your lock was taken" : "Currently being edited";
  const detail = isLost
    ? `${who} is now editing this page. Your local changes were not saved.`
    : `${who} started editing ${friendlyAge(holder?.seconds_since_ping)}${holder?.is_stale ? " (may have walked away)" : ""}.`;
  return (
    <div data-testid="edit-lock-banner"
         className="flex items-center gap-3 px-6 py-3 border-b border-amber-200 bg-amber-50 text-amber-900">
      <div className="w-8 h-8 rounded-full bg-amber-200 grid place-items-center shrink-0">
        {holder?.user_picture
          ? <img src={holder.user_picture} alt="" className="w-8 h-8 rounded-full object-cover"/>
          : <span className="text-sm font-bold">{initials}</span>}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-sm font-semibold">
          {isLost ? <AlertTriangle className="w-3.5 h-3.5"/> : <LockKeyhole className="w-3.5 h-3.5"/>}
          {label}
        </div>
        <div className="text-xs text-amber-800 truncate">{detail}</div>
      </div>
      <Button data-testid="edit-lock-takeover"
              size="sm" variant="outline"
              className="border-amber-400 hover:bg-amber-100"
              onClick={onTakeOver}>
        Take over
      </Button>
      <Button data-testid="edit-lock-close" size="sm" variant="ghost"
              className="text-amber-900 hover:bg-amber-100"
              onClick={onClose}>
        Close editor
      </Button>
    </div>
  );
}
